(function (app, ng) {
    app.provider("eligibilityFormApi", [function () {
        this.$get = ["portalApiGateway", "$cookies", function (portalApiGateway, $cookies) {
            var service = {};

            service.getSurvey = function (surveyId) {
                return portalApiGateway.get("/EligibilityForms/" + surveyId);
            };

            service.getSurveys = function () {
                return portalApiGateway.getArray("/EligibilityForms");
            };

            service.isEnrolled = function (surveyId) {
                return portalApiGateway.get("/EligibilityForms/" + surveyId + "/IsEnrolled");
            };

            service.submit = function (surveyId, answers) {
                return portalApiGateway.post("/EligibilityForms/" + surveyId + "/Answers", answers);
            };

            service.getSalesConsultants = function () {
                return portalApiGateway.getArray("/SalesConsultants");
            };
           
            service.getSurveyRenewals = function (filterBySurveyId) {             
                return portalApiGateway.getArray("/Survey/AgentSurveyRenewals").then(function (results) {                   
                    var surveys = [];
                    if (!filterBySurveyId) {
                        ng.forEach(results, function (s, i) {
                            var cookie = $cookies.get('surveyrenewal' + s.SurveyRenewalId);
                            if (cookie) {
                                s.RenewalStatus = "Ignored";
                                s.SurveyRenewalStatusId = 3;
                                s.RenewModifiedOn = cookie;
                            }

                            surveys.push(s);
                        });
                        return surveys;
                    }

                    else return _.filter(results, function (renewal) { return renewal.SurveyId === filterBySurveyId; });
                });
            };          

            service.getSurveyRenewalByOrderId = function (orderId) {
                return portalApiGateway.get("/Survey/AgentSurveyRenewalByOrderId/" + orderId);
            };

            service.getSurveyRenewalBySurveyRenewalId = function (surveyRenewalId) {
                return portalApiGateway.get("/Survey/AgentSurveyRenewalByRenewalId/" + surveyRenewalId);
            };

            service.createSurveyRenewalEvent = function (surveyRenewalId, renewalEventText) {
                var obj = {
                    "SurveyRenewalId": surveyRenewalId,
                    "RenewalEventText": renewalEventText
                };
                return portalApiGateway.post("/Survey/SubmitRenewal", obj);
            };

            service.surveyRenewalAccepted = function (surveyRenewalId, SurveyRenewalStatusId) {
                var obj = {
                    "SurveyRenewalId": surveyRenewalId,
                    "SurveyRenewalStatusId": SurveyRenewalStatusId
                };
                return portalApiGateway.post("/Survey/SubmitRenewal", obj);
            };

            service.surveyRenewalDeclined = function (surveyRenewalId, SurveyRenewalStatusId) {
                var obj = {
                    "SurveyRenewalId": surveyRenewalId,
                    "SurveyRenewalStatusId": SurveyRenewalStatusId
                };
                return portalApiGateway.post("/Survey/SubmitRenewal", obj);
            };

            service.surveyRenewalIgnored = function (surveyRenewalId) {
                var minutes = 120;

                var d = new Date();
                var dateString = (d.getMonth() + 1) + '/' + d.getDate() + '/' + d.getFullYear();

                d.setMinutes(d.getMinutes() + minutes);
                var expireDate = d;
                $cookies.put('surveyrenewal' + surveyRenewalId, dateString, { 'expires': expireDate });

                var obj = {
                    "SurveyRenewalId": surveyRenewalId,
                    "RenewalEventText": "Renewal Ignored" 
                };
                return portalApiGateway.post("/Survey/SubmitRenewal", obj);
            };

            return service;
        }];
    }]);
})(window.app, window.angular); // jshint ignore:line